import { Services } from '@sigma-frontend-libs/commons'

import { components, routerQueryReplace } from '@/utils'

import filter from '@/components/services/sendingsModeration/filter'
import sendings from '@/components/services/sendingsModeration/sendings'
import tasks from '@/components/services/sendingsModeration/tasks'
import users from '@/components/services/sendingsModeration/users'

function renderFilter(h) {
  return h(
    filter,
    {
      props: {
        value: this.filter,
        range: this.rangeForRequest,
        preset: this.preset
      },
      on: {
        input: event => {
          this.filter = event
        },
        preset: event => {
          this.preset = event
        }
      }
    }
  )
}

function renderUsers(h) {
  return h(
    users,
    {
      props: {
        users: this.users,
        loading: this.usersLoading
      },
      on: {
        userId: event => {
          this.filter.OwnerId = event
        },
        refresh: () => {
          return this.getUsers()
        }
      }
    }
  )
}
function renderSendings(h) {
  return h(
    sendings,
    {
      props: {
        filter: this.filter,
        range: this.rangeForRequest,
        sendings: this.sendings,
        provider: this.provider,
        loading: this.sendingsLoading
      },
      on: {
        refresh: () => {
          return this.getSendings()
        }
      }
    }
  )
}

function renderTab(h) {
  switch (this.currentTab) {
    case Services.sendings: {
      return h(
        'div',
        {
          class: 'grid grid-gap--8 pa-2'
        },
        [
          renderFilter.call(this, h),

          h(
            'div',
            {
              class: `${Services.sendingsModeration}-content`
            },
            [
              renderUsers.call(this, h),
              renderSendings.call(this, h)
            ]
          )
        ]
      )
    }
    case Services.tasks: return h(tasks)
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      h(
        components['tabs-header'],
        {
          props: {
            value: this.currentTabs,
            tabs: this.tabs.map(key => {
              return {
                key,
                title: this.getTranslate(`${Services.sendingsModeration}.tabs.${key}`)
              }
            })
          },
          on: {
            input: event => {
              routerQueryReplace({ currentTab: event })
            }
          }
        }
      ),
      h(
        components.card,
        {
          props: {
            rounded: true,
            outline: true,
            overflow: true
          }
        },
        [ renderTab.call(this, h) ]
      )
    ]
  )
}
